export default {"src":"/_next/static/media/search.33b266e8.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};